import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BusyService } from '../_services/busy.service';
import { GlobalService } from '../_services/global.service';
import { HttpClient } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { bmxurl, getAccess } from 'src/globals';
import { cVoucher } from 'src/types/voucher';
import { users_returndata } from 'src/types/user_returndata';
import { ActivatedRoute, Router } from '@angular/router';
import { voucher_returndata } from 'src/types/voucher_returndata';
import { cRefund, refund } from 'src/types/refund';

@Component({
  selector: 'app-voucheredit',
  templateUrl: './voucheredit.component.html',
  styleUrls: ['./voucheredit.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VouchereditComponent {

  NameValid: boolean = true;
  EmailValid: boolean = true;
  EmailFormatValid: boolean = true;

  RecipientNameValid: boolean = true;
  RecipientEmailValid: boolean = true;
  RecipientEmailFormatValid: boolean = true;
  
  messageValid: boolean = true;
  stateOptions: any[];
  Voucher: cVoucher;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  httpResponse: any;
  AccessAllowed: boolean = false;
  CompletedLoading: boolean = false;
  pageReady: boolean = true;
  id: string;
  CurrencySymbol = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  //Refunding is for Venue Administrators only, so the logged in user is kept to check against.
  CurrentLoggedInUser: any;

  displayModalRefund: boolean = false;
  RefundPayment: number;
  RefundReason: string;
  RefundPaymentId: string;
  //What is left on the payment being refunded. The box starts here, which is a full refund, and
  //can be typed down for a partial one. It cannot go above it: the rest has already been given
  //back.
  RefundMax: number = 0;

  RefundPaymentValid: boolean = true;
  RefundTextValid: boolean = true;

  constructor(private http: HttpClient, 
    private route: ActivatedRoute,
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private globalService: GlobalService) { 

      this.stateOptions = [{ label: 'No', value: false }, { label: 'Yes', value: true }];
    }

    updateData()
    {
      if (this.DoValidCheck())
      {
        this.Voucher.disabled = false;
        
        this.http.put<cVoucher>(bmxurl + "/Voucher", this.Voucher).subscribe(response => {
        this.httpResponse = response
          if(this.httpResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Saved', detail:'Voucher successfully updated'});
            this.router.navigateByUrl("/voucherlist");
          }
          else
          {
            this.messageService.add({severity:'error', summary:'Not Saved', detail:this.httpResponse.messages[0]});
            this.router.navigateByUrl("/voucherlist");
          }
          }, error => {
            this.messageService.add({severity:'error', summary:'Not Saved', detail:error.messages});
        })
      }
    }

  ngOnInit() {

    this.globalService.setSmallScreenMenu(false);

    let userid = localStorage.getItem("SmartUserID");

    this.http.get(bmxurl + "User/" + userid).subscribe(response => {
      this.httpResponse =  (response as users_returndata)
      if(this.httpResponse.succeeded)
      {
        let user = this.httpResponse.data;

        this.CurrentLoggedInUser = user;

        if(getAccess("VOUCHERS", user)){
          this.AccessAllowed = true;

          this.id = this.route.snapshot.paramMap.get('id');
          if(this.id != "0")
          {
            this.pageReady = false;
            this.http.get(bmxurl + "Voucher/" + this.VenueID + "/" + this.id).subscribe(response => {
              this.httpResponse = (response as voucher_returndata)
              if (this.httpResponse.succeeded)
              {
                this.Voucher = {
                  id: (this.httpResponse.data as cVoucher).id,
                  venueid: (this.httpResponse.data as cVoucher).venueid,
                  voucherid: (this.httpResponse.data as cVoucher).voucherid,
                  vouchercode: (this.httpResponse.data as cVoucher).vouchercode,
                  voucherpin: (this.httpResponse.data as cVoucher).voucherpin,
                  emailaddress: (this.httpResponse.data as cVoucher).emailaddress,
                  customername: (this.httpResponse.data as cVoucher).customername,
                  alternativerecipient: (this.httpResponse.data as cVoucher).alternativerecipient,
                  recipientsname: (this.httpResponse.data as cVoucher).recipientsname,
                  recipientsemailsaddress: (this.httpResponse.data as cVoucher).recipientsemailsaddress,
                  message: (this.httpResponse.data as cVoucher).message,
                  disabled:(this.httpResponse.data as cVoucher).disabled,
                  created: new Date((this.httpResponse.data as cVoucher).created),
                  expiry: new Date((this.httpResponse.data as cVoucher).expiry),
                  voucherexpiry: (this.httpResponse.data as cVoucher).voucherexpiry,
                  initialvalue:(this.httpResponse.data as cVoucher).initialvalue,
                  customamount:(this.httpResponse.data as cVoucher).customamount,
                  balance: (this.httpResponse.data as cVoucher).balance,
                  value: (this.httpResponse.data as cVoucher).value,
                  payments: (this.httpResponse.data as cVoucher).payments,
                  ischild: (this.httpResponse.data as cVoucher).ischild,
                  bookingid: (this.httpResponse.data as cVoucher).bookingid,
                  bookingidhr: (this.httpResponse.data as cVoucher).bookingidhr,
                  currency: (this.httpResponse.data as cVoucher).currency,
                  deferredpayment: (this.httpResponse.data as cVoucher).deferredpayment,
                  defernotes: (this.httpResponse.data as cVoucher).defernotes,
                  discounts: (this.httpResponse.data as cVoucher).discounts,
                  total: (this.httpResponse.data as cVoucher).total,
                  totaldiscounts: (this.httpResponse.data as cVoucher).totaldiscounts
                };
      
                this.pageReady = true;
              }
              else
              {
                this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes'});
                this.pageReady = false;
              }
            }, error => {
              this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting classes, error:' + error.messages[0]});
              this.pageReady = false;
            });
          }
        }

        this.CompletedLoading = true;

      }
    }, error => {
      this.messageService.add({severity:'error', summary:'Error', detail:'Error while getting User, error:' + error.messages[0]});
    });
  }

  returnToList()
  {
    this.router.navigateByUrl("/voucherlist");
  }


  viewBooking(ID: string)
  {
    this.router.navigateByUrl("/bookingedit/" + ID);
  }

  //What has actually been taken, net of refunds - a refund comes back as a negative row in the
  //payments list, which is what the Payments table shows.
  get totalPaid(): number {
    if(this.Voucher == null || this.Voucher.payments == null)
    {
      return 0;
    }

    let paid = 0;

    this.Voucher.payments.forEach(payment => {
      paid += (payment.amount ?? 0);
    });

    return Math.round(paid * 100) / 100;
  }

  checkIfRefundallowed()
  {
    if(this.CurrentLoggedInUser == null)
    {
      return false;
    }

    return this.CurrentLoggedInUser.accesscontrol?.name == 'Venue Administrator';
  }

  setupRefund(payment: any)
  {
    if(!this.checkIfRefundallowed())
    {
      this.messageService.add({severity:'error', summary:'Not Allowed', detail: 'You do not have authority to refund this payment, please speak to your manager.'});
      return;
    }

    //The payment id comes back spelled either way depending on where the voucher was sold.
    this.RefundPaymentId = payment.paymentId ?? payment.PaymentId;

    //What is left on this payment, not what was originally taken, so a payment that has already
    //been partly refunded cannot be refunded twice over.
    this.RefundMax = payment.balance ?? payment.amount ?? 0;
    this.RefundPayment = this.RefundMax;
    this.RefundReason = "";

    this.RefundPaymentValid = true;
    this.RefundTextValid = true;

    this.displayModalRefund = true;
  }

  closeRefund()
  {
    this.displayModalRefund = false;
    this.RefundReason = "";
    this.RefundPaymentValid = true;
    this.RefundTextValid = true;
  }

  DoRefundValidCheck()
  {
    let AllValid = true;

    if(this.RefundPayment == null || this.RefundPayment <= 0 || this.RefundPayment > this.RefundMax)
    {
      AllValid = false;
      this.RefundPaymentValid = false;
    }
    else
    {
      this.RefundPaymentValid = true;
    }

    if(this.RefundReason == null || this.RefundReason == "")
    {
      AllValid = false;
      this.RefundTextValid = false;
    }
    else
    {
      this.RefundTextValid = true;
    }

    return AllValid;
  }

  doRefund()
  {
    if (this.DoRefundValidCheck())
    {
      let newRefund: cRefund = {
        venueid: this.VenueID,
        paymentid: this.RefundPaymentId,
        reason: this.RefundReason,
        amount: this.RefundPayment,
        notes: "",
        disabled: false
      }

      this.busyService.busy();

      this.http.post<refund>(bmxurl + "/refund", newRefund).subscribe(response => {
        this.httpResponse = response

        if(this.httpResponse.succeeded)
        {
          this.messageService.add({severity:'success', summary:'Refunded', detail:'Refund successful, the refund has been passed to the card issuer and will be processed by them in accordance to their refund policy.'});

          this.closeRefund();

          //Read the voucher back rather than working the new balance out here: refunding changes
          //what is left on the voucher as well as on the payment.
          this.refreshVoucher();
        }
        else
        {
          this.messageService.add({severity:'error', summary:'Not Refunded', detail: this.httpResponse.messages[0]});
        }

        this.busyService.idle();
      }, error => {
        this.busyService.idle();
        this.messageService.add({severity:'error', summary:'Not Refunded', detail: 'The refund could not be made.'});
      })
    }
  }

  private refreshVoucher()
  {
    this.busyService.busy();

    this.http.get(bmxurl + "Voucher/" + this.VenueID + "/" + this.id).subscribe(response => {
      this.busyService.idle();

      this.httpResponse = (response as voucher_returndata)

      if(this.httpResponse.succeeded)
      {
        this.Voucher = (this.httpResponse.data as cVoucher);
        this.Voucher.created = new Date((this.httpResponse.data as cVoucher).created);
        this.Voucher.expiry = new Date((this.httpResponse.data as cVoucher).expiry);
      }
    }, error => {
      this.busyService.idle();
      this.messageService.add({severity:'error', summary:'Error', detail:'The refund was made, but the voucher could not be read back. Reload the page to see it.'});
    });
  }


  DoValidCheck(){
    let AllValid = true;

    if(this.Voucher.customername == "")
    {
      AllValid = false;
      this.NameValid = false;
    }
    else
    {
      this.NameValid = true;
    }

    if(this.Voucher.emailaddress == "")
    {
      AllValid = false;
      this.EmailValid = false;
    }
    else
    {
      this.EmailValid = true;
    }

    if (this.Voucher.emailaddress != "") {
      if (!this.validateEmail(this.Voucher.emailaddress)) {
        AllValid = false;
        this.EmailFormatValid = false;
      }
      else {
        this.EmailFormatValid = true;
      }
    }

    if(this.Voucher.alternativerecipient)
    {
      if(this.Voucher.recipientsname == "")
      {
        AllValid = false;
        this.RecipientNameValid = false;
      }
      else
      {
        this.RecipientNameValid = true;
      }
  
      if(this.Voucher.recipientsemailsaddress == "")
      {
        AllValid = false;
        this.RecipientEmailValid = false;
      }
      else
      {
        this.RecipientEmailValid = true;
      }

      if (this.Voucher.recipientsemailsaddress != "") {
        if (!this.validateEmail(this.Voucher.recipientsemailsaddress)) {
          AllValid = false;
          this.RecipientEmailValid = false;
        }
        else {
          this.RecipientEmailValid = true;
        }
      }

      if(this.Voucher.message == "")
      {
        AllValid = false;
        this.messageValid = false;
      }
      else
      {
        this.messageValid = true;
      }
    }

    return AllValid;
  }

  validateEmail(email){ 
    var re = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/; 
    return re.test(email); 
  }


}